
const EndIcon = () => (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H20C24.4183 0.5 28 4.08172 28 8.5V20.5C28 24.9183 24.4183 28.5 20 28.5H8C3.58172 28.5 0 24.9183 0 20.5V8.5Z" fill="#F04438" />
    <path d="M8.2915 6.16675V22.8334" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.2915 7.83325H17.6248C19.8748 7.83325 20.3748 9.08325 18.7915 10.6666L17.7915 11.6666C17.1248 12.3333 17.1248 13.4166 17.7915 13.9999L18.7915 14.9999C20.3748 16.5833 19.7915 17.8333 17.6248 17.8333H8.2915" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)

export default EndIcon
